import { get, post } from '@/apis/http';
import { apiPath } from '@/config';
import { cmsApis } from '@/config/cmsApi';
const cmsXianApi='/cmsApi';
// 转发CMS接口
export function postCmsSystemRelay(name, data = {}) {
  const path = cmsApis[name];
  return post( apiPath + '/common/pmCmsSystemRelay?path=' + path, data)
}

// 转发CMS详情接口
export function pmCmsSystemRelayUrlParam(name, data = {}) {
  const path = cmsApis[name];
  return post(apiPath + '/common/pmCmsSystemRelayUrlParam?path=' + path, data)
}

// 转发用户MT数据库
export function ucTransferParam(name, data = {}) {
  const path = cmsApis[name];
  return post(apiPath + '/uc/userInfo/transferSend?path=' + path, data)
}





// 转发活动页接口  /uc/activity
export function getActicityParam(name, data = {}) {
  const path =cmsApis[name]
  return post(apiPath + '/uc/activity?path=' + path, data)
}

// cms上传图片接口
// 上传图片
export function postUploadImgCms(data) {
  return post('/cmsApi/File/Upload', data, {
    headers: {
      'Content-Type': 'multipart/form-data; boundary=----'
    }
  })
}

// 转发好友助力活动post /uc/h5invite/friendassist
export function postFriendAssist(name, data = {}) {
  const path = cmsApis[name]
  return post(apiPath + '/uc/h5invite/friendassist?path=' + path, data)
}
// 赔付活动 
export function getCompensate(name, data = {}) {
  const path = cmsApis[name]
  return post(apiPath + '/uc/paylosses?path=' + path, data)
}
// 首充预增转发
export function postFirstadvamtCRM(name, data = {}) {
  const path = cmsApis[name];
  return post(apiPath + '/uc/firstadvamt?path=' + path, data)
}

//交易保障计划uc/protectnewtrade?path=
export function postProtectnewtrade(name, data = {}) {
  const path = cmsApis[name];
  return post(apiPath + '/uc/protectnewtrade?path=' + path, data)
}